import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './FloatingPageNav.css'; // Make sure the CSS file is imported

// The component now accepts three props: prevLink, indexLink, and nextLink
const FloatingPageNav = ({ prevLink, indexLink, nextLink }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  // Helper component to handle scrolling to the top on navigation
  const ScrollToTopLink = ({ to, children }) => {
    const handleClick = () => {
      // 1. Smoothly scroll to the top of the window
      window.scrollTo({
        top: 0,
        behavior: 'smooth' 
      });
      // 2. Close the navigation menu after clicking a link
      setIsOpen(false);
    };

    // Use 'to' prop as the dynamic link destination
    return (
      <Link to={to} onClick={handleClick}>
        {children}
      </Link>
    );
  };

  return (
    <div className="floating-nav-container">
      
      {/* The navigation options */}
      <div className={`nav-options ${isOpen ? 'open' : ''}`}>
        
        {/* PREV Button: Renders only if prevLink is provided */}
        {prevLink && (
          <ScrollToTopLink to={prevLink}>
            <button className="nav-button prev-button">
              Prev
            </button>
          </ScrollToTopLink>
        )}
        
        {/* INDEX Button: Always present, using indexLink (which you can hardcode in the parent if it's always '/index') */}
        <ScrollToTopLink to={indexLink || "/index"}> 
          <button className="nav-button index-button">
            Index
          </button>
        </ScrollToTopLink>
        
        {/* NEXT Button: Renders only if nextLink is provided */}
        {nextLink && (
          <ScrollToTopLink to={nextLink}>
            <button className="nav-button next-button">
              Next
            </button>
          </ScrollToTopLink>
        )}
      </div>

      {/* The main floating button (toggle button) */}
      <button 
        className="floating-toggle-button" 
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        {isOpen ? 'Close Nav ▲' : 'Open Nav ▼'}
      </button>
    </div>
  );
};

export default FloatingPageNav;